import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";

const Company = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 이메일무단수집거부`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });

    // IP 체크 함수
    const checkIP = async () => {
      const response = await fetch("/check-ip");
      const result = await response.json();

      // 리다이렉션 확인
      if (result.redirect) {
        navigate(result.redirect); // navigate로 리다이렉션
      }
    };

    checkIP(); // IP 체크 함수 호출
  }, [location, navigate]); // navigate 추가

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/policy">개인정보처리방침</a>
              </li>
              <li>
                <a href="/email" className="sel">
                  이메일무단수집거부
                </a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="terms">
          <div className="wrap">
            <div className="title">이메일무단수집거부</div>
            <div className="cont">
              <div className="text">
                본 웹사이트에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그
                밖의 기술적 장치를 이용하여 무단으로 수집되는 것을 거부하며,
                이를 위반시 정보통신망법에 의해 형사처벌됨을 유념하시기
                바랍니다.
                <br />
                <strong>
                  제50조의 2 (전자우편주소의 무단 수집행위 등 금지)
                </strong>
                ① 누구든지 인터넷 홈페이지 운영자 또는 관리자의 사전 동의 없이
                인터넷 홈페이지에서 자동으로 전자우편주소를 수집하는
                프로그램이나 그 밖의 기술적 장치를 이용하여 전자우편주소를
                수집하여서는 아니 된다.
                <br />
                ② 누구든지 제1항을 위반하여 수집된 전자우편주소를
                판매·유통하여서는 아니 된다.
                <br />③ 누구든지 제1항과 제2항에 따라 수집·판매 및 유통이 금지된
                전자우편주소임을 알면서 이를 정보 전송에 이용하여서는 아니
                된다.[전문개정 2008.6.13]
                <strong>제74조 (벌칙)</strong>
                다음 각 호의 어느 하나에 해당하는 자는 1년 이하의 징역 또는
                1천만원 이하의 벌금에 처한다.
                <br />
                - 제8조제4항을 위반하여 비슷한 표시를 한 제품을 표시·판매 또는
                판매할 목적으로 진열한 자<br />
                - 제44조의7제1항제1호의 규정을 위반하여 음란한
                부호·문언·음향·화상 또는 영상을 배포·판매·임대하거나 공공연하게
                전시한 자<br />
                - 제44조의7제1항제3호의 규정을 위반하여 공포심이나 불안감을
                유발하는 부호·문언·음향·화상 또는 영상을 반복적으로 상대방에게
                도달하게 한 자<br />
                - 제50조제6항의 규정을 위반하여 기술적 조치를 한 자<br />
                - 제50조의8을 위반하여 광고성 정보를 전송한 자<br />-
                제53조제4항을 위반하여 등록사항의 변경등록 또는 사업의 양도·양수
                또는 합병·상속의 신고를 하지 아니한 자
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Company;
